import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import Image_Show_Modal from "../../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import { formatDate } from "../../../../../../../../utils/common";

const Use_Of_Reference_Material_Table = ({
  setEdit,
  validitydetails,
  setCurrentPage,
  currentPage,
}) => {
  const perPage =
    validitydetails?.per_page || validitydetails?.data?.length || 0;

  const filteredData = validitydetails?.data || [];
  const totalPages = validitydetails?.total_pages;
  console.log(filteredData, "filteredData validitydetails validitydetails");
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const maxObservations = Math.max(
    ...(filteredData || []).map(
      (item) => item.Validity_Type_Record_Observations?.length || 0,
    ),
    0,
  );

  const [show, setShow] = useState(false);

  const [showData, setShowData] = useState("");

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th rowSpan="2">Sr.No</th>
                <th rowSpan="2">Date</th>
                <th rowSpan="2">Test Type</th>
                <th rowSpan="2">Sample ID</th>
                <th rowSpan="2">Certified Value</th>
                <th rowSpan="2">Test Method</th>
                <th colSpan={maxObservations}>Observations</th>

                <th rowSpan="2">Avg.</th>
                <th rowSpan="2">Tested By</th>
                <th rowSpan="2">Remark</th>
                <th rowSpan="2">Action</th>

                {/* <th rowSpan="2">Action</th> */}
              </tr>
              <tr>
                {Array.from({ length: maxObservations }).map((_, i) => (
                  <th key={i}>OBS {String(i + 1).padStart(2, "0")}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * perPage + index + 1}</td>
                    <td>{formatDate(item.createdAt) || "-"}</td>
                    <td>{item.Test_Type?.name || "-"}</td>
                    <td>{item.Sample_Management?.unique_id || "-"}</td>
                    <td>{item.certified_value || "-"}</td>
                    <td>{item.Test_Method?.name || "-"}</td>

                    {/* Display up to 5 observations */}
                    {Array.from({ length: maxObservations }).map(
                      (_, obsIndex) => (
                        <td key={obsIndex}>
                          {item.Validity_Type_Record_Observations?.[obsIndex]
                            ?.observation_value || "-"}
                        </td>
                      ),
                    )}

                    <td>{item.average || "-"}</td>
                    <td>{item.Tested_By?.name || "-"}</td>
                    <td>{item.remark || "-"}</td>

                    <td>
                      <div
                        className="action_icons"
                        onClick={() => {
                          setShow(true);
                          setShowData(item);
                        }}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={9} style={{ textAlign: "center" }}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show m-0">
            {`Showing ${Math.min(
              (currentPage - 1) * perPage + 1,
            )} to ${Math.min(
              currentPage * perPage,
              validitydetails?.total,
            )} of ${validitydetails?.total} entries`}
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>

        <Image_Show_Modal
          onHide={() => setShow(false)}
          show={show}
          showData={showData}
          imgSrc={process.env.REACT_APP_IMG_URL + showData?.attach_file}
        />
      </div>
    </>
  );
};

export default Use_Of_Reference_Material_Table;
